import { Text, TextProps } from '@chakra-ui/react'
import * as React from 'react'

import { vw } from '../../styles/theme'

export type TextProps = TextProps & {}

export const TextBody: React.FC<TextProps> = ({ children, ...others }) => {
  return (
    <Text fontSize={[vw(10), '18px']} lineHeight={[vw(15), '32px']} mb="1em" {...others}>
      {children}
    </Text>
  )
}

export const TextSmall: React.FC<TextProps> = ({ children, ...others }) => {
  return (
    <Text fontSize={[vw(8), '12px']} lineHeight={[vw(14), '24px']} {...others}>
      {children}
    </Text>
  )
}
